import {
  InvestmentsExperimentFlag,
  MarketInvestmentsRoutesEnum,
  StoreInvestmentsRoutesEnum
} from 'investments/common/enums'
import BlackBird from 'shared/blackbird'
import { useExperiment } from 'shared/experiment'

import { useDeusExMachina } from '~/domains/platform/infra/deus-ex-machina/hocs/with-deus-ex-machina'

export function useProductsOfferNavigation() {
  const { deusExMachina } = useDeusExMachina()
  const subjectId = deusExMachina?.subject.id ?? ''

  const { isFeatureFlagEnabled } = useExperiment(
    subjectId,
    InvestmentsExperimentFlag.StoreInvestmentsNewModule
  )

  const goToProductsOffer = () =>
    BlackBird.travelTo(
      isFeatureFlagEnabled
        ? StoreInvestmentsRoutesEnum.DEPOSIT_PRODUCTS_OFFER
        : MarketInvestmentsRoutesEnum.PRODUCTS_OFFERS
    )

  return { goToProductsOffer }
}
